/**
 * 百度商桥 / 统计脚本按路由加载，避免 SPA 全局出现在线咨询浮窗。
 * 在下方数组中配置需要展示咨询入口的路由 path。
 */
const BAIDU_HM_SRC = 'https://hm.baidu.com/hm.js?2250dfd02d9cbcc1c361df9b5788d0a7'

export const BAIDU_CONSULT_ROUTES = ['/home', '/price']

const HIDE_SELECTORS = [
  '#newBridge',
  '.newBridge-bar',
  '#aff-im-root',
  '#zc__sdk__container',
  '[id*="bd-im"]',
  '[class*="newBridge"]',
  'iframe[src*="baidu.com"]',
  'iframe[src*="affim"]'
]

let hmLoaded = false

export function shouldShowBaiduConsult(path) {
  return BAIDU_CONSULT_ROUTES.includes(path)
}

function loadBaiduHm() {
  if (hmLoaded || document.querySelector(`script[src="${BAIDU_HM_SRC}"]`)) {
    hmLoaded = true
    return
  }

  window._hmt = window._hmt || []
  const hm = document.createElement('script')
  hm.src = BAIDU_HM_SRC
  hm.async = true
  document.head.appendChild(hm)
  hmLoaded = true
}

function setWidgetVisibility(visible) {
  HIDE_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => {
      if (visible) {
        el.style.display = ''
        el.style.visibility = ''
        el.style.pointerEvents = ''
        el.style.height = ''
        el.style.maxHeight = ''
        el.style.overflow = ''
        return
      }

      el.style.display = 'none'
      el.style.visibility = 'hidden'
      el.style.pointerEvents = 'none'
      el.style.height = '0'
      el.style.maxHeight = '0'
      el.style.overflow = 'hidden'
    })
  })
}

export function syncBaiduConsult(path) {
  if (shouldShowBaiduConsult(path)) {
    document.body.classList.remove('hide-baidu-consult')
    loadBaiduHm()
    setWidgetVisibility(true)
    return
  }

  document.body.classList.add('hide-baidu-consult')
  setWidgetVisibility(false)
}



// WEBPACK FOOTER //
// ./src/utils/baiduConsult.js